import * as ActionType from 'constants/action-types/organization';

export default (state, { type, payload }) => {
  switch (type) {
    case ActionType.GET_HELPER_LIST_START:
      return {
        ...state,
        helpersList: {
          ...state.helpersList,
          loading: true,
          error: null,
        },
      };
    case ActionType.GET_HELPER_LIST_SUCCESS:
      return {
        ...state,
        helpersList: {
          ...state.helpersList,
          data: payload,
          error: null,
          loading: false,
        },
      };
    case ActionType.GET_HELPER_LIST_ERROR:
      return {
        ...state,
        helpersList: {
          ...state.helpersList,
          data: payload,
          error: null,
          loading: false,
        },
      };

    default:
      return null;
  }
};
